import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const NoSearchResults = () => {
  const { t } = useTranslation();
  return (
    <div className="mt-[80px] h-full w-full flex flex-col items-center justify-center bg-background-surface">
      <div className="h-14 w-14 flex items-center justify-center border-background-surface-neutral bg-background-surface-neutral-subtle border-8 rounded-full">
        <div className="w-6 h-6">
          <SearchIcon />
        </div>
      </div>
      <div className="font-medium text-xl mt-5 text-text-base-primary">
        {t("dashboard.transactions.no_search_results")}
      </div>
      <div className="font-normal text-base mt-2 text-text-base-secondary">
        {t("dashboard.transactions.no_search_results_message")}
      </div>
    </div>
  );
};

const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
      <g clipPath="url(#clip0_3421_2488)">
        <path
          fill="currentColor"
          d="M12.021 11.078l2.856 2.854-.944.944-2.854-2.856a6.002 6.002 0 01-9.745-4.687c0-3.312 2.688-6 6-6a6.002 6.002 0 014.687 9.745zm-1.337-.495a4.665 4.665 0 00-3.35-7.917 4.665 4.665 0 00-4.667 4.667 4.665 4.665 0 007.917 3.35l.1-.1z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_3421_2488">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
